import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { listWithCategories } from '../constants';
import { DefaultFilterMetadataWire } from '../types';
import { DefaultFilterMetadata } from '../types-store';

export const mapFilterMetadata = (filterMetadata: DefaultFilterMetadataWire): DefaultFilterMetadata =>
({
  domain: codeItemToStoreValue(filterMetadata?.domain),
  advancedSearchType: filterMetadata?.advancedSearchType,
  codetable: filterMetadata?.codetable,
  categoryCodetable: listWithCategories.includes(filterMetadata?.advancedSearchType)
    ? filterMetadata?.categoryCodetable : undefined,
  searchRequired: filterMetadata?.searchRequired
});
